/**
 * API client de integracao CAD (Fase 4 Bloco C+E — ADR-0016, ADR-0017).
 *
 * Bloco C (upload XML):
 *   GET  /api/cad/adapters
 *   POST /api/orcamentos/{id}/importar-projeto-3d?adapter=dinabox-file
 *        body multipart: arquivo=<XML>
 *
 * Bloco E (DinaBox via API):
 *   CRUD /api/cad/configs
 *   POST /api/cad/configs/{id}/testar
 *   GET  /api/cad/projetos?adapter=&unidade=&page=&qty=&search=&status=
 *   POST /api/orcamentos/{id}/importar-projeto-3d?adapter=dinabox-api
 *        body JSON: {projeto_externo_id}
 */

const PREFIXO = "/api/cad";

// ---------- Adapters (publico) ----------

export function listarAdaptersCad(request) {
  return request(`${PREFIXO}/adapters`);
}

// ---------- Configuracoes de credenciais (Bloco E) ----------

export function listarConfigsCad(request, { adapter, unidade } = {}) {
  const usp = new URLSearchParams();
  if (adapter) usp.set("adapter", adapter);
  if (unidade) usp.set("unidade", unidade);
  const qs = usp.toString();
  return request(`${PREFIXO}/configs${qs ? `?${qs}` : ""}`);
}

export function criarConfigCad(request, payload) {
  return request(`${PREFIXO}/configs`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });
}

export function atualizarConfigCad(request, id, payload) {
  return request(`${PREFIXO}/configs/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });
}

export function excluirConfigCad(request, id) {
  return request(`${PREFIXO}/configs/${id}`, { method: "DELETE" });
}

export function testarConfigCad(request, id) {
  // 400 OK conceitualmente — quem chama trata `ok: false`.
  return request(`${PREFIXO}/configs/${id}/testar`, {
    method: "POST",
    silentError: true,
  });
}

// ---------- Listagem de projetos via adapter (Bloco E) ----------

export function listarProjetosCad(
  request,
  { adapter, unidade, page = 1, qty = 20, search = "", status = "" } = {},
) {
  const usp = new URLSearchParams();
  usp.set("adapter", adapter);
  usp.set("unidade", unidade);
  usp.set("page", String(page));
  usp.set("qty", String(qty));
  if (search) usp.set("search", search);
  if (status) usp.set("status", status);
  return request(`${PREFIXO}/projetos?${usp.toString()}`);
}

// ---------- Import de projeto 3D no orcamento ----------

/**
 * Importa projeto CAD criando 1 Ambiente novo no orcamento.
 *
 * Modos:
 *   - adapter de arquivo (dinabox-file): passe `arquivo` (File).
 *   - adapter de API    (dinabox-api):  passe `projetoExternoId` (string).
 *
 * Use exatamente UM dos dois.
 */
export function importarProjeto3D(
  request,
  orcamentoId,
  { adapter, arquivo, projetoExternoId },
) {
  const usp = new URLSearchParams();
  if (adapter) usp.set("adapter", adapter);
  const qs = usp.toString();
  const url = `/api/orcamentos/${orcamentoId}/importar-projeto-3d${qs ? `?${qs}` : ""}`;

  if (projetoExternoId) {
    return request(url, {
      method: "POST",
      body: JSON.stringify({ projeto_externo_id: projetoExternoId }),
      headers: { "Content-Type": "application/json" },
    });
  }

  // Fallback: arquivo (modo Bloco C)
  const formData = new FormData();
  formData.append("arquivo", arquivo);
  return request(url, { method: "POST", body: formData });
}
